export default "__VITE_ASSET__3a5Q0KNZ__"